import {Enum} from 'enumify'

class TaskTypeIconParser extends Enum {}
TaskTypeIconParser.initEnum({
  ADDMULCH: {
    iconsrc: 'mulchinstallation',
    apiName: 'ADDMULCH',
    prettify: 'Mulch Installation'
  },
  AERATELAWN: {
    iconsrc: 'aeration',
    apiName: 'AERATELAWN',
    prettify: 'Aeration'
  },
  BUSHTRIMMING: {
    iconsrc: 'bushtrimming',
    apiName: 'BUSHTRIMMING',
    prettify: 'Bush Trimming'
  },
  BUSHREMOVAL: {
    iconsrc: 'bushremoval',
    apiName: 'BUSHREMOVAL',
    prettify: 'Bush Removal'
  },
  CHANGEFILTER: {
    iconsrc: 'changeairfilter',
    apiName: 'CHANGEFILTER',
    prettify: 'Change Air Filter'
  },
  CLEANCARPETS: {
    iconsrc: 'carpetcleaning',
    apiName: 'CLEANCARPETS',
    prettify: 'Carpet Cleaning'
  },
  CLEANHOUSE: {
    iconsrc: 'housecleaning',
    apiName: 'CLEANHOUSE',
    prettify: 'House Cleaning'
  },
  CLEARGUTTERS: {
    iconsrc: 'cleargutters',
    apiName: 'CLEARGUTTERS',
    prettify: 'Clear Gutters'
  },
  CONTROLPESTS: {
    iconsrc: 'pestremoval',
    apiName: 'CONTROLPESTS',
    prettify: 'Pest Removal'
  },
  AQUAMAN: {
    iconsrc: 'aquaman',
    apiName: 'AQUAMAN',
    prettify: 'Custom'
  },
  CUSTOM: {
    iconsrc: 'customtask',
    apiName: 'CUSTOM',
    prettify: 'Custom Task'
  },
  GREENMAN: {
    iconsrc: 'greenman',
    apiName: 'GREENMAN',
    prettify: 'Custom'
  },
  SCOPINGTOOL: {
    iconsrc: 'scopingtool',
    apiName: 'SCOPINGTOOL',
    prettify: 'Scoping Tool'
  },
  DEBRISREMOVAL: {
    iconsrc: 'debrisremoval',
    apiName: 'DEBRISREMOVAL',
    prettify: 'Debris Removal'
  },
  DESERTSCAPE: {
    iconsrc: 'desertscape',
    apiName: 'DESERTSCAPE',
    prettify: 'Desertscape'
  },
  DETHATCHING: {
    iconsrc: 'dethatching',
    apiName: 'DETHATCHING',
    prettify: 'Dethatching'
  },
  EDGING: {
    iconsrc: 'edging',
    apiName: 'EDGING',
    prettify: 'Edging'
  },
  FALLCLEANUP: {
    iconsrc: 'fallcleanup',
    apiName: 'FALLCLEANUP',
    prettify: 'Fall Cleanup'
  },
  FERTILIZELAWN: {
    iconsrc: 'fertilization',
    apiName: 'FERTILIZELAWN',
    prettify: 'Fertilization'
  },
  FIXSPRINKLERS: {
    iconsrc: 'sprinklerrepair',
    apiName: 'FIXSPRINKLERS',
    prettify: 'Sprinkler Repair'
  },
  HOLIDAYLIGHTING: {
    iconsrc: 'holidaylighting',
    apiName: 'HOLIDAYLIGHTING',
    prettify: 'Holiday Lighting'
  },
  INSPECTPROPERTY: {
    iconsrc: 'propertyinspection',
    apiName: 'INSPECTPROPERTY',
    prettify: 'Property Inspection'
  },
  INSTALLCARPET: {
    iconsrc: 'carpetinstallation',
    apiName: 'INSTALLCARPET',
    prettify: 'Carpet Installation'
  },
  IRRIGATIONINSPECTION: {
    iconsrc: 'irrigationinspection',
    apiName: 'IRRIGATIONINSPECTION',
    prettify: 'Irrigation Inspection'
  },
  LEAFREMOVAL: {
    iconsrc: 'leafcleanup',
    apiName: 'LEAFREMOVAL',
    prettify: 'Leaf Cleanup'
  },
  MOWLAWN: {
    iconsrc: 'lawnmowing',
    apiName: 'MOWLAWN',
    prettify: 'Lawn Mowing'
  },
  MULCHREFRESH: {
    iconsrc: 'mulchrefresh',
    apiName: 'MULCHREFRESH',
    prettify: 'Mulch Refresh'
  },
  PAINTWALLS: {
    iconsrc: 'paintwalls',
    apiName: 'PAINTWALLS',
    prettify: 'Paint Walls'
  },
  PALMTRIMMING: {
    iconsrc: 'palmtrimming',
    apiName: 'PALMTRIMMING',
    prettify: 'Palm Trimming'
  },
  PETWASTECLEANUP: {
    iconsrc: 'petwastecleanup',
    apiName: 'PETWASTECLEANUP',
    prettify: 'Pet Waste Cleanup'
  },
  PLANTING: {
    iconsrc: 'planting',
    apiName: 'PLANTING',
    prettify: 'Planting'
  },
  POOLCLEANING: {
    iconsrc: 'poolcleaning',
    apiName: 'POOLCLEANING',
    prettify: 'Pool Cleaning'
  },
  PRESSUREWASHING: {
    iconsrc: 'pressurewashing',
    apiName: 'PRESSUREWASHING',
    prettify: 'Pressure Washing'
  },
  PURPLEMAN: {
    iconsrc: 'purpleman',
    apiName: 'PURPLEMAN',
    prettify: 'Custom'
  },
  REMOVEINDOORTRASH: {
    iconsrc: 'garbageremoval',
    apiName: 'REMOVEINDOORTRASH',
    prettify: 'Garbage Removal'
  },
  REMOVETRASH: {
    iconsrc: 'trashremoval',
    apiName: 'REMOVETRASH',
    prettify: 'Trash-Out'
  },
  ROCKINSTALLATION: {
    iconsrc: 'rockinstallation',
    apiName: 'ROCKINSTALLATION',
    prettify: 'Rock Installation'
  },
  ROCKREFRESH: {
    iconsrc: 'rockrefresh',
    apiName: 'ROCKREFRESH',
    prettify: 'Rock Refresh'
  },
  SALESCLEAN: {
    iconsrc: 'salesclean',
    apiName: 'SALESCLEAN',
    prettify: 'Sales Clean'
  },
  SEEDING: {
    iconsrc: 'seeding',
    apiName: 'SEEDING',
    prettify: 'Seeding'
  },
  SHOWPROPERTY: {
    iconsrc: 'showproperty',
    apiName: 'SHOWPROPERTY',
    prettify: 'Turns'
  },
  SHUTDOWNPROPERTY: {
    iconsrc: 'propertyshutdown',
    apiName: 'SHUTDOWNPROPERTY',
    prettify: 'Shutdown'
  },
  PLOWSNOW: {
    iconsrc: 'snowremoval',
    apiName: 'PLOWSNOW',
    prettify: 'Snow Removal'
  },
  SODINSTALLATION: {
    iconsrc: 'sodinstallation',
    apiName: 'SODINSTALLATION',
    prettify: 'Sod Installation'
  },
  SPRINGCLEANUP: {
    iconsrc: 'springcleanup',
    apiName: 'SPRINGCLEANUP',
    prettify: 'Spring Cleanup'
  },
  SPRINKLERTURNOFF: {
    iconsrc: 'sprinklerturnoff',
    apiName: 'SPRINKLERTURNOFF',
    prettify: 'Sprinkler OFF'
  },
  SPRINKLERTURNON: {
    iconsrc: 'sprinklerturnon',
    apiName: 'SPRINKLERTURNON',
    prettify: 'Sprinkler ON'
  },
  STUMPREMOVAL: {
    iconsrc: 'stumpremoval',
    apiName: 'STUMPREMOVAL',
    prettify: 'Stump Removal'
  },
  TOPSOILINSTALLATION: {
    iconsrc: 'topsoilinstallation',
    apiName: 'TOPSOILINSTALLATION',
    prettify: 'Topsoil Installation'
  },
  TREEREMOVAL: {
    iconsrc: 'treeremoval',
    apiName: 'TREEREMOVAL',
    prettify: 'Tree Removal'
  },
  TREETRIMMING: {
    iconsrc: 'treetrimming',
    apiName: 'TREETRIMMING',
    prettify: 'Tree Trimming'
  },
  VINEREMOVAL: {
    iconsrc: 'vineremoval',
    apiName: 'VINEREMOVAL',
    prettify: 'Vine Removal'
  },
  VINETRIMMING: {
    iconsrc: 'vinetrimming',
    apiName: 'VINETRIMMING',
    prettify: 'Vine Trimming'
  },
  WASHWINDOWS: {
    iconsrc: 'cleanwindows',
    apiName: 'WASHWINDOWS',
    prettify: 'Clean Windows'
  },
  WEEDING: {
    iconsrc: 'weeding',
    apiName: 'WEEDING',
    prettify: 'Weeding'
  },
  YARDCLEANUP: {
    iconsrc: 'yardcleanup',
    apiName: 'YARDCLEANUP',
    prettify: 'Yard Cleanup'
  },
  WATERING: {
    iconsrc: 'watering',
    apiName: 'WATERING',
    prettify: 'Watering'
  }
})
export function getTaskTypeIconParser (apiName) {
  for (const type of TaskTypeIconParser.enumValues) {
    if (type.apiName === apiName) {
      return type
    }
  }
}

export function getTaskTypes () {
  return TaskTypeIconParser.enumValues
}
export default TaskTypeIconParser



// WEBPACK FOOTER //
// ./src/components/shared/enums/task-type-icon-parser.js